import { Component, OnInit, OnDestroy, computed, inject } from '@angular/core';
import { UnivPrefsService } from '_services/univ-prefs.service';
import { UserService } from '_services/user.service';
import { EclService } from '_services/ecl.service';
import { WelcomeService } from '_services/welcome.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  ups = inject(UnivPrefsService);
  us = inject(UserService);
  ecl = inject(EclService);
  welcome = inject(WelcomeService);
  router = inject(Router);

  public small = false;
  public headerHeight = 100;
  public logoutUrl = 'https://account.collegeboard.org/login/logout?appId=250&DURL=';
  readonly environment = environment;

  // Computed signal for headerShrink based on preferences
  private headerShrink = computed(() => {
    const prefs = this.ups.preferences();
    return prefs ? !prefs.headerShrink : false;
  });

  public scroll: EventListener = (event: any) => {
    const scroll = event.srcElement?.scrollTop || 0;
    if (this.headerShrink()) {
      this.setHeaderHeight(scroll);
    }
  };



  ngOnInit() {
    window.addEventListener('scroll', this.scroll, true);

  }

  private setHeaderHeight(number: number) {
    const fullHeight = 100; // Same as headerHeight default above
    const smallHeight = 50;
    const buffer = 10;


    if (number >= buffer && number <= smallHeight + buffer) {
      this.headerHeight = fullHeight + buffer - number;
    } else if (number > smallHeight + buffer) {
      this.headerHeight = smallHeight;
    } else if (number < buffer) {
      this.headerHeight = fullHeight;
    }
  }


  ngOnDestroy() {
    window.removeEventListener('scroll', this.scroll, true);
  }

  // "Sign in anywhere" — snapshot answers and redirect to College Board.
  // Auto-completes the login (mock env drives the resume/claim automatically).
  signIn() {
    void this.welcome.startCbLogin();
  }

  /** Dev/mock only — prod uses the College Board logout link in the template. */
  logout() {
    this.ecl.mockLogout();
  }

}
